import { render, staticRenderFns } from "./MenuSearch.vue?vue&type=template&id=51ffe084"
import script from "./MenuSearch.vue?vue&type=script&lang=js"
export * from "./MenuSearch.vue?vue&type=script&lang=js"
import style0 from "./MenuSearch.vue?vue&type=style&index=0&id=51ffe084&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports